import { useIntl } from "react-intl";

type EnvironmentBannerProps = {
  label: string;
};

export function EnvironmentBanner({ label }: EnvironmentBannerProps) {
  const intl = useIntl();

  if (!label) {
    return null;
  }

  return (
    <div
      role="status"
      className="shrink-0 bg-red-700 px-4 py-0.5 text-center text-xs font-bold tracking-wide text-white"
    >
      {intl.formatMessage(
        {
          id: "environment-banner.text",
          defaultMessage:
            "{label} – neprodukčné prostredie, údaje a dokumenty nemajú právne účinky",
        },
        { label },
      )}
    </div>
  );
}

export function environmentDocumentTitle(label: string, title: string) {
  return label ? `[${label}] ${title}` : title;
}
